<template>
  <el-dialog
    ref="dialog"
    title="Выбрать вакансию"
    :visible.sync="is_visible"
    :close-on-click-modal="false"
    class="dialog"
    width="640px"
    @close="$emit('reset-callback')"
  >
    <form novalidate ref="form">
      <Dropdown
        :field="fields.vacancy"
        :model="form.vacancy"
        :options="vacancies"
        filterable
        @set-value="handleChange"
      />
    </form>
    <div slot="footer">
      <div class="footer">
        <Button
          buttonSize="big"
          buttonColor="blue"
          buttonText="Отменить"
          @click="$emit('reset-callback')"
          class="button-cancel"
        />
        <Button
          buttonSize="big"
          buttonColor="darkBlue"
          buttonText="Позвонить"
          :disabled="!form.vacancy"
          @click.prevent="makeCall"
          class="accept-button"
          :class="!form.vacancy && 'no-pointer'"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';
import { store } from '@/store';
import { scrollToErrorField } from '@/utils/helpers';
import { mixin, rules } from '@/utils/mixins';
import Button from 'Elements/Button/Button';
import Dropdown from 'Elements/Select/Dropdown';
export default {
  mixins: [mixin, rules],
  props: {
    is_visible: {
      type: Boolean
    }
  },
  data() {
    return {
      form: {},
      fields: {
        vacancy: {
          name: 'vacancy',
          required: true,
          placeholder: 'Вакансия',
          type: 'enum'
        }
      },
      rules: {}
    };
  },
  created() {
    for (let key in this.field) {
      if (this.field[key].required) {
        this.setRequiredFields(true, this.field[key]);
      }
    }
  },
  computed: {
    vacancies() {
      return (store.state.candidate.vacanciesForCall || []).map(v => ({
        id: v?.intents?.intents?.request?.request_params?.vacancy_id,
        name: v?.fields?.schema?.name?.text || '[без наименования]'
      }));
    }
  },
  methods: {
    handleChange(name, val) {
      this.$set(this.form, name, val);
      this.validateForm(this.form, name);
    },
    makeCall() {
      if (!this.form.vacancy) return;
      const valid = this.validateForm(this.form);
      scrollToErrorField(this.fields, this.$refs.dialog.$el);

      if (valid) {
        store.dispatch('candidate/makeCall', { vacancy: this.form.vacancy });
        this.$emit('reset-callback');
      } else {
        console.log('Заполните обязательные поля!');
      }
    }
  },
  destroyed() {
    store.commit('candidate/setParam', {
      name: 'selectedContact',
      val: null
    });
  },
  components: {
    'el-dialog': Dialog,
    Button,
    Dropdown
  }
};
</script>
<style lang="scss" scoped>
#front .dialog {
  & ::v-deep .el-dialog {
    padding: 12px 24px 24px;

    & > .el-dialog__header {
      & > .el-dialog__title {
        font-family: 'Roboto Medium';
        font-size: 18px !important;
        line-height: 28px !important;
      }

      button {
        height: 24px;
      }
    }

    .el-dialog__footer {
      margin: 36px 0 0 0;

      .footer {
        justify-content: unset;
        display: block;

        .button-cancel {
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
